import axios from 'axios'
import { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { baseUrl } from '../constants/url'

const AdminLogin = () => {
    const [isLoggedin, setIsLoggedIn] = useState(false)
    const [otpSent, setOtpSent] = useState(false)
    const [mobile, setMobile] = useState('')
    const [otp, setOtp] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const navigate = useNavigate()

    const sendOTP = async (e) => {
        e.preventDefault();
        setError("");
        if (mobile) {
            try {
                setLoading(true);
                let response = await fetch(`${baseUrl}/login`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        mobileNo: mobile,
                        isAdmin: true,
                    }),
                });
                const data = await response.json();
                if ((response.status >= 200 && response.status < 300) || response.status === 304) {
                    if (data.message.includes("No member found")) {
                        setError("No member found for this mobile number!");
                        return;
                    }
                    setOtpSent(true);
                } else {
                    response = await response.json();
                    setError(response.message);
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        }
    };

    const login = async (e) => {
        try {
            e.preventDefault();
            setLoading(true);
            setError("");
            const res = await fetch(`${baseUrl}/verifyuser`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    mobileNo: mobile,
                    OTPText: parseInt(otp),
                    isAdmin: true,
                }),
            });
            const data = await res.json();
            if (res.status === 200) {
                if (data.data.token) {
                    localStorage.setItem('localuser', JSON.stringify(data.data));
                    localStorage.setItem('MemberAuth', data.data.token);
                    localStorage.setItem('MemberCode', data.data.memberCode);
                    localStorage.setItem('MemberId', data.data.memberId);
                    // Keep legacy keys in sync for components that still rely on them
                    localStorage.setItem('Authorization', data.data.token);
                    localStorage.setItem('lastAuthTimeMillis', String(new Date().getTime()));
                    localStorage.setItem('isAdminLogin', true);
                    setIsLoggedIn(true);
                }
            } else {
                setError(data.message);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isLoggedin) {
            navigate('/admin/dashboard')
        }
    }, [isLoggedin])

    return (
        <>
            <div className="login">
                <div className="login-page">
                    <h1>Admin Login</h1>
                    <div className="card">
                        <form className="form-part">
                            <div className="form-field phone-no-field">
                                <input
                                    disabled={loading}
                                    type="tel"
                                    placeholder="Enter Phone No"
                                    value={mobile}
                                    onChange={(e) => {
                                        setMobile(e.target.value);
                                        setError("");
                                    }}
                                />
                                <button
                                    disabled={!mobile || mobile.length !== 10}
                                    onClick={sendOTP}
                                    className="send-otp-link"
                                    type="button"
                                >
                                    Send OTP
                                </button>
                            </div>
                            <div className="form-field">
                                <input
                                    disabled={!otpSent || loading}
                                    placeholder="OTP"
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                />
                            </div>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            <div className="button-part">
                                <button
                                    onClick={login}
                                    className="submit-btn"
                                    disabled={!otpSent || loading}
                                    type="button"
                                >
                                    {loading ? 'Loading...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminLogin
